import { render, staticRenderFns } from "./PesquisaArrematante.vue?vue&type=template&id=5dccf9c0"
import script from "./PesquisaArrematante.vue?vue&type=script&lang=js"
export * from "./PesquisaArrematante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports